import Approval from './purchase/approval';
import Search from './purchase/search';
import Request from './purchase/request';

export default {
  Approval,
  Search,
  Request,
};
